<template>
  <v-card :key="mode">
    <v-card-text v-if="object">
      <v-container>
        <v-card outlined style="border: 1px solid #1976d2;">
          <div bottom class="text-h6">Datos Generales</div>
          <!-- Fila 1 -->
          <v-row dense>
            <v-col>
              <v-text-field
                hide-details
                label="Fecha"
                id="date"
                v-model="object.date_formatted"
                disabled
              />
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                v-model="object.person_name"
                :label="object.client_code ? 'Cliente' : 'Destinatario'"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="personSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <!-- eslint-disable -->
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.person
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="personSelected(null)"
                >
                  mdi-close
                </v-icon>
                <!-- eslint-enable -->
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                hide-details
                label="Categoria"
                id="person_category"
                :value="
                  object.person_category_description
                    ? object.person_category_description
                    : ''
                "
                disabled
              />
            </v-col>
          </v-row>
          <!-- Fila 2 -->
          <v-row dense>
            <v-col>
              <v-autocomplete
                :disabled="!editing"
                label="Campaña"
                :items="quotationCampaignItems"
                hide-details
                hide-no-data
                hide-selected
                item-text="code"
                item-value="url"
                v-model="object.campaign"
                return-object
                @change="campaignSelected($event)"
                ref="campaignAutocomplete"
                prepend-icon="mdi-close"
                @click:prepend="clearAutocomplete('campaignAutocomplete')"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                :disabled="!editing"
                label="Cultivo"
                :items="quotationCropItems"
                hide-details
                hide-no-data
                hide-selected
                item-text="description"
                item-value="url"
                v-model="object.crop"
                return-object
                @change="cropSelected($event)"
                ref="cropAutocomplete"
                prepend-icon="mdi-close"
                @click:prepend="clearAutocomplete('cropAutocomplete')"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                v-model="object.payment_condition_description"
                label="Condición de Pago"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="paymentConditionSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.payment_condition
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="paymentConditionSelected(null)"
                >
                  mdi-close
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
          <!-- Fila 3 -->
          <v-row dense>
            <v-col>
              <v-text-field
                disabled
                v-show="!editing"
                hide-details
                label="Cantidad Mínima de Bolsas Dto. por Volúmen"
                type="number"
                v-model="object.total_quantity"
              />
              <v-autocomplete
                v-show="editing"
                :disabled="!editing"
                label="Descuento por Volúmen"
                :items="quotationScaleItems"
                hide-details
                hide-no-data
                hide-selected
                :item-text="getScaleText"
                item-value="from_quantity"
                v-model="object.total_quantity"
                @change="scaleSelected($event)"
                ref="scaleAutocomplete"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-checkbox
                :disabled="!editing"
                hide-details
                :label="d3Description"
                v-model="object.advance_dispatch"
                @change="advanceDispatchChange()"
              />
            </v-col>
          </v-row>
          <!-- Fila 4 -->
          <v-row dense>
            <v-col>
              <v-textarea
                :disabled="!editing"
                hide-details
                clearable
                label="Observación Interna"
                v-model="object.internal_comments"
                rows="1"
                auto-grow
              />
            </v-col>
            <v-col>
              <v-textarea
                :disabled="!editing"
                hide-details
                clearable
                label="Texto (IMPRESO EN DOCUMENTACIÓN ENTREGADA AL CLIENTE)"
                v-model="object.comments"
                rows="1"
                auto-grow
                color="red"
              />
            </v-col>
          </v-row>
        </v-card>
        <!-- Items -->
        <v-row dense>
          <v-col colse="12">
            <div class="table-footer-prepend d-flex pl-2 align-center">
              <v-tooltip top>
                <template v-slot:activator="{ activationEvents }">
                  <v-btn
                    icon
                    :disabled="!editing"
                    outlined
                    color="primary"
                    v-on="activationEvents"
                    @click="addNewItem"
                  >
                    <v-icon :class="editing ? 'enabled-icon' : 'disabled-icon'">
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Agregar</span>
              </v-tooltip>
            </div>
            <v-data-table
              dense
              :headers="quotationItemsHeadersVisible"
              :items="object.quotation_items"
              hide-default-header
            >
              <!-- pagination template -->
              <template v-slot:top="{ pagination, options, updateOptions }">
                <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                />
              </template>
              <!-- eslint-disable -->
              <!-- header template -->
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th
                      v-for="item in headers"
                      :key="item.value"
                      class="column"
                      @click="item.canLock ? changeLock(item.value) : ''"
                      :style="
                        (item.width ? 'width: ' + item.width + '; min-width: ' + item.width + ';' : '')
                      "
                    >
                      {{ item.text }}
                      <v-icon v-if="item.canLock && editing" small>{{ item.locked ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}</v-icon>
                    </th>
                  </tr>
                </thead>
              </template>
              <!-- item template -->
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.item_number">
                    <td v-if="editing">
                      <v-icon v-show="editing" small @click.stop="deleteItem(item)">
                        mdi-delete
                      </v-icon>
                    </td>
                    <td>{{ item.item_number }}</td>
                    <td v-if="editing">
                      <v-icon @click.stop="itemInventorySearchClick(item)">
                        mdi-magnify
                      </v-icon>
                    </td>
                    <td class="theme--light v-input--is-disabled">{{ item.product_code ? item.product_description : "" }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.gauge_code !== item.gauge_description ? item.gauge_code + " - " + item.gauge_description : item.gauge_code }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.band_data.band_description }}</td>
                    <td>
                      <v-input
                        :disabled="!editing"
                        dense
                        hide-details
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.quantity"
                          :id="
                            'R' + item.item_number.toString() + 'Cquantity'
                          "
                          @input="cellChange(index, 'quantity')"
                          :options = "{
                            decimalPlaces: '0'
                          }"
                          style="text-align:right;"
                          size="5"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td style="border: 1px solid black;">
                      <v-input
                        :disabled="!editing || object.recalc_field == 'unit_price_usd'"
                        dense
                        hide-details
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.unit_price_usd"
                          :id="
                            'R' + item.item_number.toString() + 'Cunit_price_usd'
                          "
                          @input="cellChange(index, 'unit_price_usd')"
                          :options = "{
                            decimalPlaces: '4'
                          }"
                          style="text-align:right;"
                          size="7"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td>
                      <v-input disabled dense hide-details>
                        <vue-autonumeric
                          slot="default"
                          :value="item.unit_price_usd * item.quantity"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ctotal_item_usd'
                          "
                          :options="{
                            decimalPlaces: '2'
                          }"
                          style="text-align:right;"
                          size="7"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td v-if="quotationShowItemPriceSubtotals" class="theme--light v-input--is-disabled" style="border: 1px solid #1976d2;">{{ item.list_unit_price_usd }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b1_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b2_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b3_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.d1_discount }}</td>
                    <td v-if="quotationShowItemPriceSubtotals" class="theme--light v-input--is-disabled" style="border: 1px solid #1976d2;">{{ item.net_unit_price_usd }}</td>
                    <td>
                      <v-input
                        :disabled="!editing || object.recalc_field == 'leader_discount' || object.person_category_code == '5'"
                        dense
                        :hide-details="true"
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.leader_discount"
                          :id="
                            'R' + item.item_number.toString() + 'Cleader_discount'
                          "
                          @input="cellChange(index, 'leader_discount')"
                          :options = "{
                            decimalPlaces: '6'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td
                      :style="!$bRoot.isNullOrEmpty(item, 'company_discount') ? 'border: 1px solid #E3002C;' : ''"
                    >
                      <v-input
                        :disabled="!editing || object.recalc_field == 'company_discount'"
                        dense
                        :hide-details="true"
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.company_discount"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ccompany_discount'
                          "
                          @input="cellChange(index, 'company_discount')"
                          :options = "{
                            decimalPlaces: '6'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td>
                      <v-text-field
                        disabled
                        hide-details
                        single-line
                        dense
                        v-model="item.company_discount_motive_description"
                        label="Motivo Dto. LG"
                        :id="
                          'R' +
                            item.item_number.toString() +
                            'Ccompany_discount_motive'
                        "
                      >
                        <v-icon
                          slot="append-outer"
                          :class="(editing && !$bRoot.isNullOrEmpty(item, 'company_discount')) ? 'enabled-icon' : 'disabled-icon'"
                          @click="itemCompanyDiscountMotiveSearchClick(item)"
                        >
                          mdi-magnify
                        </v-icon>
                        <!-- eslint-disable -->
                        <v-icon
                          slot="prepend"
                          :class="
                            editing && item.company_discount_motive
                              ? 'enabled-icon'
                              : 'disabled-icon'
                          "
                          @click="itemCompanyDiscountMotiveSelected(null, item)"
                        >
                          mdi-close
                        </v-icon>
                        <!-- eslint-enable -->
                      </v-text-field>
                    </td>
                    <td
                      v-if="quotationShowItemPriceSubtotals"
                      class="theme--light v-input--is-disabled"
                    >
                      {{ item.spot_unit_price_usd }}
                    </td>
                    <td>
                      <v-input disabled dense hide-details>
                        <vue-autonumeric
                          slot="default"
                          :value="item.total_commission_usd"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ctotal_commision_usd'
                          "
                          :options="{
                            decimalPlaces: '2'
                          }"
                          style="text-align:right;"
                          size="7"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td class="theme--light v-input--is-disabled">
                      {{ item.percentage_commission }}
                    </td>
                    <td class="theme--light v-input--is-disabled">
                      {{ item.inventory_client_code }}
                    </td>
                  </tr>
                </tbody>
              </template>
              <!-- eslint-enable -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="quotationShowSearch"
      :show="quotationShowSearch"
      :title="quotationSearchOptions.title"
      :endpoint="quotationSearchOptions.endpoint"
      :ordering="quotationSearchOptions.ordeting"
      :searchLabel="quotationSearchOptions.searchLabel"
      :headers="quotationSearchOptions.headers"
      :filterString="quotationSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="quotationSearchOptions.searchOnURL"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>

    <!-- component for magnify inventory search -->
    <!-- eslint-disable -->
    <inventory-search-dialog
      v-if="quotationShowInventorySearch"
      :show="quotationShowInventorySearch"
      :campaign="object.campaign_object"
      :crop="object.crop_object"
      :product="object.quotation_items[quotationItemIndex].product"
      :gauge="object.quotation_items[quotationItemIndex].gauge"
      :curing="object.quotation_items[quotationItemIndex].curing"
      :only_positives=0
      :orderDocument="quotationDocument"
      @itemSelected="itemInventorySelected($event)"
      @cancel="itemInventoryCanceled"
    >
    </inventory-search-dialog>
    <!-- eslint-enable -->
    <!-- component for magnify payment_condition search -->
    <payment-condition-search-dialog
      v-if="quotationShowPaymentConditionSearch"
      :show="quotationShowPaymentConditionSearch"
      :order="object"
      :disableInterest="true"
      @itemSelected="paymentConditionSelected($event)"
      @cancel="paymentConditionCanceled"
    >
    </payment-condition-search-dialog>
  </v-card>
</template>
<script>
import DataQuotation from "@/components/clon/DataQuotation.js";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import InventorySearchDialog from "@/components/InventorySearchDialog.vue"; // Review!
import PaymentConditionSearchDialog from "@/components/PaymentConditionSearchDialog.vue";
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  name: "QuotationEdit",

  components: {
    PaginatedSearchDialog,
    InventorySearchDialog,
    PaymentConditionSearchDialog,
    VueAutonumeric
  },

  props: ["value", "initialmode"],

  data() {
    return {
      object: null,
      current_level: null,
      editing: false,
      mode: null,
      quotation: new DataQuotation(this.$bRoot),
      quotationShowSearch: null,
      quotationShowInventorySearch: null,
      quotationShowPaymentConditionSearch: null,
      quotationItemIndex: null,
      quotationSearchOptions: null,
      quotationCampaignItems: [],
      quotationCropItems: [],
      quotationScaleItems: [],
      quotationFilterItem: null,
      quotationFilterCampaign: null,
      quotationFilterCrop: null,
      quotationShowItemPriceSubtotals: false,
      d3Description: "Dto.3",
      quotationDocument: null,
      quotationItemsHeaders: [
        { text: "Item", value: "item_number", sortable: false },
        {
          text: "Producto",
          value: "product_code",
          sortable: false,
          width: "200px"
        },
        { text: "Calibre", value: "gauge_code", sortable: false },
        {
          text: "Banda",
          value: "band_data.band_description",
          sortable: false,
          width: "150px"
        },
        { text: "Cantidad", value: "quantity", sortable: false },
        {
          text: "Precio Venta Financiado USD",
          value: "unit_price_usd",
          sortable: false,
          canLock: true,
          locked: true
        },
        {
          text: "Total Item",
          value: "total_item_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Precio Lista Contado USD",
          value: "list_unit_price_usd",
          sortable: false,
          align: "end"
        },
        {
          text: "% Dto. Cliente",
          value: "b1_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "% Dto. Volúmen",
          value: "b2_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "Dto.3",
          value: "b3_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "% Dto. Promoción",
          value: "d1_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "Precio Bonificado Contado USD",
          value: "net_unit_price_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "% Descuento Agente",
          value: "leader_discount",
          sortable: false,
          canLock: true,
          locked: false
        },
        {
          text: "% Descuento LG",
          value: "company_discount",
          sortable: false,
          canLock: true,
          locked: false
        },
        {
          text: "Motivo Dto. LG",
          value: "company_discount_motive",
          sortable: false,
          width: "220px"
        },
        {
          text: "Precio Venta Contado USD",
          value: "spot_unit_price_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Comisión Total",
          value: "total_commission_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Comisión Porcentual",
          value: "percentage_commission",
          sorteable: false,
          align: "end"
        }
      ]
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    editing: {
      handler() {
        this.editingChange();
      }
    },
    deep: true
  },

  computed: {
    quotationItemsHeadersVisible() {
      if (this.quotationShowItemPriceSubtotals) {
        return this.quotationItemsHeaders;
      }
      return this.quotationItemsHeaders.filter(
        header =>
          ![
            "list_unit_price_usd",
            "net_unit_price_usd",
            "spot_unit_price_usd"
          ].includes(header.value)
      );
    }
  },

  methods: {
    changeLock(value) {
      this.object.recalc_field = value;
      this.quotationItemsHeaders.forEach((element, index, items_array) => {
        if (element.canLock === true) {
          items_array[index].locked = element.value === value;
        }
      });
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.quotationFilterCampaign = null;
          this.object = await this.quotation.setCampaign(this.object);
          break;
        case "cropAutocomplete":
          this.quotationCrop = null;
          this.object = await this.quotation.setCrop(this.object);
          await this.loadScales();
          break;
      }
    },

    paymentConditionSearchClick() {
      this.quotationShowPaymentConditionSearch = true;
    },

    personSearchClick() {
      this.quotationSearchOptions = {
        headers: [
          { text: "Código", value: "client_code", sortable: false },
          {
            text: "Identificación",
            value: "person_identification",
            sortable: false
          },
          { text: "Nombre", value: "name", sortable: false },
          {
            text: "Categoría",
            value: "person_category_description",
            sorteable: false
          }
        ],
        title: "Cliente/Productores...",
        endpoint:
          "/data/quotable_persons_hierarchy/" +
          this.object.campaign_id.toString(),
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "personSelected",
        searchOnURL: true
      };
      this.quotationShowSearch = true;
    },

    itemInventorySearchClick(item) {
      if (!this.object.campaign) {
        this.$bRoot.setError("Seleccione Campaña");
      } else if (!this.object.crop) {
        this.$bRoot.setError("Seleccione Cultivo");
      } else if (!this.object.person) {
        this.$bRoot.setError("Seleccione Cliente/Destinatario");
      } else {
        // eslint-disable-next-line
        this.quotationItemIndex = this.object.quotation_items.findIndex(oitem => oitem.item_number == item.item_number);
        this.quotationShowInventorySearch = true;
      }
    },

    itemCompanyDiscountMotiveSearchClick(item) {
      this.quotationItemIndex = this.object.quotation_items.findIndex(
        oitem => oitem.item_number == item.item_number
      );
      this.quotationSearchOptions = {
        headers: [
          { text: "Código", value: "code", sortable: false },
          { text: "Descripción", value: "description", sortable: false }
        ],
        title: "Motivo Descuento LG...",
        endpoint: "/data/company_discount_motives",
        ordering: "description",
        searchLabel: "Descripcion",
        filterString: null,
        selected: "itemCompanyDiscountMotiveSelected",
        searchOnURL: false
      };
      this.quotationShowSearch = true;
    },

    itemInventoryCanceled() {
      this.quotationItemIndex = null;
      this.quotationShowInventorySearch = null;
    },

    paymentConditionCanceled() {
      this.quotationShowPaymentConditionSearch = null;
    },

    searchSelected(data) {
      this[this.quotationSearchOptions.selected](data, this.quotationSearchOptions.row); // eslint-disable-line
      this.searchCanceled();
    },

    searchCanceled() {
      this.quotationShowSearch = false;
      this.quotationSearchOptions = {};
    },

    async paymentConditionSelected(paymentCondition) {
      this.object = await this.quotation.setPaymentCondition(
        this.object,
        paymentCondition,
        null
      );
      this.paymentConditionCanceled();
    },

    async campaignSelected(campaign) {
      this.quotationFilterCampaign = campaign;
      this.object = await this.quotation.setCampaign(this.object, campaign);
    },

    async cropSelected(crop) {
      this.quotationFilterCrop = crop;
      this.object = await this.quotation.setCrop(this.object, crop);
      await this.loadScales();
    },

    async personSelected(person) {
      if (person) {
        this.object = await this.quotation.clearItems(this.object);
        this.object = await this.quotation.setPerson(this.object, person, null);
      } else {
        this.object = await this.quotation.setPerson(this.object);
      }
      await this.loadScales();
    },

    async scaleSelected() {
      this.object = await this.quotation.totalQuantityChange(this.object);
    },

    async loadScales() {
      this.quotationScaleItems = await this.quotation.getDiscountScales(
        this.object
      );
    },

    async advanceDispatchChange() {
      this.object = await this.quotation.advanceDispatchChange(this.object);
    },

    async totalQuantityChange() {
      this.object = await this.quotation.totalQuantityChange(this.object);
    },

    async itemInventorySelected(inventory) {
      this.object = await this.itemChange(
        this.quotationItemIndex,
        "inventory",
        inventory
      );
      this.itemInventoryCanceled();
    },

    async itemCompanyDiscountMotiveSelected(motive, item) {
      if (!this.quotationItemIndex && item) {
        this.quotationItemIndex = this.object.quotation_items.findIndex(
          oitem => oitem.item_number == item.item_number
        );
      }
      this.object = await this.itemChange(
        this.quotationItemIndex,
        "company_discount_motive",
        motive
      );
    },

    async itemChange(item_index, fieldName, object) {
      let res = await this.quotation.itemChange(
        this.object,
        item_index,
        fieldName,
        object
      );
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
      return res.quotation;
    },

    async addNewItem() {
      this.object = await this.quotation.addNewItem(this.object);
    },

    async deleteItem(item) {
      this.object = await this.quotation.deleteItem(this.object, item);
    },

    async cellChange(item_index, field_name) {
      this.$nextTick(async () => {
        this.object = await this.itemChange(item_index, field_name);
      });
    },

    /* eslint-disable */
    getScaleText(item) {
      if (item) {
        let text =
          (item["from_quantity"]
            ? item["from_quantity"].toString() +
              (item["from_quantity"] <= 1 ? " bolsa" : " bolsas")
          : "") +
          " o más";
        return text;
      } else {
        return "";
      }
    },
    /* eslint-enable */

    async save() {
      this.$bRoot.errors = null;
      let added = null;
      try {
        added = await this.quotation.save(this.object);
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        if (added) {
          this.object = added;
          this.mode = "show";
          this.editing = false;
          this.$emit("endEdit", added);
        } else {
          this.$emit("actionCanceled", added);
        }
      }
    },

    async duplicate() {
      this.object = await this.quotation.duplicate(this.object);
    },

    async changeState(state_code) {
      this.$bRoot.errors = null;
      if (state_code == this.object.state_code) {
        return;
      }
      try {
        await this.quotation.changeState(this.object, state_code);
        this.$emit("endEdit");
      } catch (error) {
        this.$emit("actionCanceled");
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    async printInternal() {
      await this.quotation.printInternal(this.object);
    },

    async printClient() {
      await this.quotation.printClient(this.object);
    },

    async editingChange() {
      let index = null;

      //delete header column
      index = this.quotationItemsHeaders.findIndex(
        item => item.value === "delete"
      );
      if (this.editing) {
        if (index === -1) {
          this.quotationItemsHeaders.splice(0, 0, {
            text: "",
            value: "delete",
            sorteable: false
          });
        }
      } else {
        if (index !== -1) {
          this.quotationItemsHeaders.splice(index, 1);
        }
      }

      //inventory header column
      index = this.quotationItemsHeaders.findIndex(
        item => item.value === "inventory"
      );
      if (this.editing) {
        if (index === -1) {
          this.quotationItemsHeaders.splice(2, 0, {
            text: "Stock Disponible",
            value: "inventory",
            sorteable: false
          });
        }
      } else {
        if (index !== -1) {
          this.quotationItemsHeaders.splice(index, 1);
        }
      }

      if (this.editing) {
        this.quotationScaleItems = await this.quotation.getDiscountScales(
          this.object
        );
      }
    },

    onlyNumbers(event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    }
  },

  async mounted() {
    this.mode = this.initialmode;

    // get description for discount code 3
    let DiscountCode = await this.quotation.getDiscountCode("3");

    if (DiscountCode) {
      this.d3Description = DiscountCode.description;
      this.quotationItemsHeaders.forEach((element, index, items_array) => {
        if (element.value === "b3_discount") {
          items_array[index].text = "% " + DiscountCode.description;
        }
      });
    }

    //campaigns
    let campaigns = await this.quotation.getCampaigns();
    this.quotationCampaignItems = campaigns.data.results;

    //crops
    let crops = await this.quotation.getCrops();
    this.quotationCropItems = crops.data.results;

    this.object = this.value;
    this.current_level = this.$bRoot.auth.current_level;

    this.editing = this.mode === "edit" || this.mode == "new";
    this.object.recalc_field = "unit_price_usd";

    //quotationDocument
    this.quotationDocument = await this.quotation.getDocument();
  }
};
</script>
<style>
.inputCol input[type="number"] {
  -moz-appearance: textfield;
  text-align: right;
  width: 60px;
}
.inputCol input::-webkit-outer-spin-button,
.inputCol input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
